class PPCVehicleSearch extends HTMLElement {
  connectedCallback() {
    if (this.started) return;
    this.started = true;
    this.config = JSON.parse(this.querySelector('[data-config]').textContent);
    this.config.root = this.config.root.replace(/\/?$/, '/');
    this.labels = this.config.labels;
    this.selects = [...this.querySelectorAll('select')];
    this.status = this.querySelector('[role="status"]');
    this.results = this.querySelector('[data-results]');
    this.submit = this.querySelector('[type="submit"]');
    this.more = this.querySelector('[data-more]');
    this.cache = new Map();
    this.generation = 0;
    this.querySelector('form').addEventListener('submit', e => { e.preventDefault(); this.search(); });
    this.querySelector('[data-reset]').addEventListener('click', () => this.reset());
    this.more.addEventListener('click', () => this.showMore());
    this.selects.forEach((s, i) => s.addEventListener('change', () => this.change(i)));
    this.load();
  }
  async json(url) {
    const response = await fetch(url);
    if (!response.ok) throw new Error('request');
    return response.json();
  }
  options(index, values) {
    const select = this.selects[index];
    select.replaceChildren(new Option(index < 3 ? this.labels.choose : this.labels.all, ''));
    values.forEach(v => select.add(new Option(v, v)));
    select.disabled = !values.length;
  }
  async load() {
    this.status.textContent = this.labels.loading;
    try {
      this.index = await this.json(this.config.index);
      this.options(0, Object.keys(this.index.years).sort((a,b) => b-a));
      this.status.textContent = this.labels.ready;
    } catch { this.status.textContent = this.labels.error; }
  }
  clearResults() {
    this.generation++;
    this.results.replaceChildren();
    this.more.hidden = true;
    this.submit.disabled = true;
    this.toggleGrid(false);
  }
  toggleGrid(hide) {
    const grid = document.querySelector('#ProductGridContainer');
    if (grid) grid.hidden = hide;
  }
  reset() {
    this.clearResults();
    this.selects[0].value = '';
    for (let i=1;i<5;i++) this.options(i, []);
    this.status.textContent = this.labels.ready;
  }
  async change(index) {
    this.clearResults();
    const token = this.generation;
    for (let i=index+1;i<5;i++) this.options(i, []);
    const [year,make,model,trim] = this.selects.map(s=>s.value);
    this.status.textContent = this.labels.ready;
    if (!year) return;
    if (index===0) { this.options(1, Object.keys(this.index.years[year]).sort()); return; }
    if (!make) return;
    if (index===1) { this.options(2, this.index.years[year][make].slice().sort()); return; }
    if (!model) return;
    this.status.textContent = this.labels.loading;
    try {
      if (!this.cache.has(make)) this.cache.set(make, Promise.all(this.config.makes[make].map(url => this.json(url))).then(chunks => chunks.flat()));
      const data = await this.cache.get(make);
      if (token!==this.generation) return;
      this.data = data;
      const rows = this.data.flatMap(p=>p[3]).filter(r=>+year>=r[0] && +year<=r[1] && model===r[2]);
      if (index===2) this.options(3, [...new Set(rows.map(r=>r[3]).filter(Boolean))].sort());
      if (index<=3) this.options(4,[...new Set(rows.filter(r=>!trim||r[3]===trim).map(r=>r[4]).filter(Boolean))].sort());
      this.submit.disabled = false;
      this.status.textContent = this.labels.ready;
    } catch {
      this.cache.delete(make);
      if (token===this.generation) this.status.textContent = this.labels.error;
    }
  }
  search() {
    if (!this.data || this.submit.disabled) return;
    this.generation++;
    const [year,,model,trim,drive] = this.selects.map(s=>s.value);
    this.matches = this.data.filter(p=>p[3].some(r=>+year>=r[0]&&+year<=r[1]&&model===r[2]&&(!trim||trim===r[3])&&(!drive||drive===r[4]))).sort((a,b)=>a[2].localeCompare(b[2]));
    this.results.replaceChildren();
    this.offset = 0;
    this.status.textContent = this.matches.length+' '+this.labels.matches;
    this.toggleGrid(true);
    this.showMore();
  }
  async showMore() {
    const token = this.generation;
    const batch = this.matches.slice(this.offset,this.offset+12);
    this.offset += batch.length;
    this.more.hidden = this.offset>=this.matches.length;
    const cards = batch.map(p=>{
      const card=document.createElement('article'); card.className='ppc-vehicle-card';
      const title=document.createElement('h3');title.textContent=p[2];card.append(title);
      const sku=document.createElement('p');sku.textContent=this.labels.sku+' '+p[0];card.append(sku);
      const details=document.createElement('p');details.className='ppc-vehicle-price';details.textContent=this.labels.loading;card.append(details);
      this.results.append(card);return {p,card,title,details};
    });
    let next=0;
    const worker=async()=>{while(next<cards.length){const {p,card,title,details}=cards[next++];
      try {
        const product=await this.json(this.config.root+'products/'+encodeURIComponent(p[1])+'.js');
        if(token!==this.generation) return;
        if(product.featured_image){const img=document.createElement('img');img.src=product.featured_image;img.alt=product.title;img.loading='lazy';img.width=360;img.height=270;card.prepend(img);}
        title.textContent=product.title;
        details.textContent=new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:window.Shopify?.currency?.active||this.config.currency}).format(product.price/100);
        const link=document.createElement('a');link.href=this.config.root+'products/'+encodeURIComponent(p[1]);link.className='button';link.textContent=this.labels.view;card.append(link);
        if(!product.available){const stock=document.createElement('p');stock.textContent=this.labels.unavailable;card.append(stock);}
      } catch {if(token===this.generation) details.textContent=this.labels.notlisted;}
    }};
    await Promise.all([worker(),worker(),worker(),worker()]);
  }
}
if (!customElements.get('ppc-vehicle-search')) customElements.define('ppc-vehicle-search', PPCVehicleSearch);
